import CustomAttribute from 'models/custom_attribute';
import GatewayErrorSilentHandler from 'scripts/application/lib/gateway_error_silent_handler';

export default class CustomAttributesGatewayObserver {
  constructor(context) {
    this.context = context;
    this.errorHandler = new GatewayErrorSilentHandler(this.context);
  }

  onBroadcast(dto) {
    this.store.addOrReplace(CustomAttribute.fromJs(dto));
  }

  onFetchAllSuccess(dtos) {
    this.store.resetLoading();
    if (dtos) {
      this.store.set(dtos.map(attr => CustomAttribute.fromJs(attr)));
    }
  }

  onFetchAllError(err) {
    this.store.resetLoading();
    this.errorHandler.handleCommonErrors(err);
  }

  get store() {
    return this.context.stores.customAttributes;
  }
}
